export default "__VITE_ASSET__DmAQE5uC__"